import OdAlertsResponseEntry from 'lumen/utils/datamodels/overview-dashboard/od-alerts-response-entry';

export default class OdAlertsResponse {
  alerts = [];
  keyDates = [];
  meta = {};

  constructor(alerts, keyDates, meta) {
    this.alerts = alerts.map((alertData) =>
      OdAlertsResponseEntry.fromApiResponse(alertData),
    );
    this.keyDates = keyDates.map((keyDatesData) =>
      OdAlertsResponseEntry.fromApiResponse(keyDatesData),
    );
    this.meta = meta;
  }

  static createEmptyResponse() {
    return new OdAlertsResponse([], [], {});
  }

  static fromApiResponse(apiResponse) {
    return new OdAlertsResponse(
      apiResponse.alerts,
      apiResponse.key_dates,
      apiResponse.meta,
    );
  }
}
